import { base64 } from "../consts/base64";
import Svg from "./figs/Svg";

export default function CardTourDetail({
  srcImage,
  tourName,
  tourDateTime,
  tourTripDuration,
  tourDestinationList,
}) {
  return (
    <div className="tour">
      <div className="image">
        <img src={srcImage || base64.emptyImage} alt={tourName} />
      </div>
      <div className="detail">
        <div className="header">{tourName}</div>
        <div className="list">
          <div className="list_detail">
            <Svg iconName="calendar" />
            <span>{tourDateTime}</span>
          </div>
          <div className="list_detail">
            <Svg iconName="clock" />
            <span>{tourTripDuration}</span>
          </div>
          <div className="list_detail">
            <Svg iconName="location" />
            <span className="destination_list">
              {tourDestinationList.map((el, index, self) => (
                <span key={index}>{`${el}${
                  index < self.length - 1 ? ", " : ""
                } `}</span>
              ))}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
